import { useRouteMatch } from "react-router";

export const useDomainID = () => {
  const match = useRouteMatch<{ domainID: string | undefined }>();
  const { domainID } = match.params;

  return domainID;
};
